// ============================================================
// [NEW-CUSTOM] 三段式工具栏：视图切换交互
// 文件名：custom-collection-view.js
// ============================================================

// ========== [NEW-CUSTOM] 视图切换 - 开始 ==========
(function () {
  'use strict';

  var STORAGE_KEY = 'cpg_view_mode';

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function applyView(mode) {
    var grid = getGrid();
    if (!grid) return;

    grid.classList.remove('cpg-view-grid', 'cpg-view-list');
    grid.classList.add('cpg-view-' + mode);
    grid.setAttribute('data-cpg-view', mode);

    var btns = document.querySelectorAll('.cpg-view-switch__btn');
    btns.forEach(function (btn) {
      var isActive = btn.getAttribute('data-view') === mode;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      /* localStorage 不可用时静默 */
    }
  }

  function initSwitchButtons() {
    var btns = document.querySelectorAll('.cpg-view-switch__btn');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-view');
        if (mode !== 'grid' && mode !== 'list') return;
        applyView(mode);
      });
    });
  }

  function readSavedView() {
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      return (saved === 'list' || saved === 'grid') ? saved : 'grid';
    } catch (e) {
      return 'grid';
    }
  }

  function init() {
    // 只在自定义工具栏存在时才执行
    if (!document.querySelector('[data-cpg-toolbar]')) return;

    applyView(readSavedView());
    initSwitchButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// ========== [NEW-CUSTOM] 视图切换 - 结束 ==========